module.exports = __webpack_public_path__ + "img/healthcare-section1.ffd4a2e3.svg";